'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initLineItemContainer = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateQuantity = function updateQuantity(data) {
  var change = 'quantity';
  var container = 'line-item';

  (0, _handlers.setState)(Object.assign({ container: container, change: change }, data));
};

var initLineItemContainer = exports.initLineItemContainer = function initLineItemContainer(lineItemContainer) {
  return new Promise(function (resolve) {
    var cart = _state2.default.get('cart');
    var lineItem = (0, _handlers.parseContainerData)(lineItemContainer)['line-item'][0];
    var cartLineItem = cart.items.find(function (_ref) {
      var id = _ref.id;
      return id === lineItem.variantId;
    }) || {};

    var id = lineItemContainer.dataset.containerId;

    var container = 'line-item';
    var change = 'init';
    var quantity = cartLineItem.quantity || parseInt($(_Dom2.default.quantityValue, lineItemContainer).val());

    (0, _handlers.setState)(Object.assign({ id: id, container: container, change: change }, lineItem, { quantity: quantity, _data: lineItem }));

    resolve(Object.assign({ id: id, container: container, change: change }, lineItem, { quantity: quantity, _data: lineItem }));
  });
};

exports.default = {
  updateQuantity: updateQuantity,
  initLineItemContainer: initLineItemContainer
};